import React from "react";
import {
  Instagram,
  Facebook,
  Linkedin,
  Twitter,
  Mail,
} from "lucide-react";

interface MicrositeContactUsProps {
  themeColor?: string;
  contactDetails: {
    contactEmail: string;
    facebook: string;
    instagram: string;
    linkedin?: string;
    twitter?: string;
    pinterest?: string;
  };
}

const MicrositeContactUs: React.FC<MicrositeContactUsProps> = ({
  themeColor = "#885ABB",
  contactDetails,
}) => {
  const quickLinks = [
    { label: "Home", href: "home" },
    { label: "About", href: "about" },
    { label: "Services", href: "services" },
    { label: "Testimonials", href: "testimonial" },
    { label: "Gallery", href: "gallery" },
  ];

  // Smooth scroll handler
  const handleScroll = (id: string) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  return (
      <footer
      className="border-t border-gray-200 font-serif scroll-smooth"
      style={{ borderTop: `3px solid ${themeColor}` }}
    >
      <div className="max-w-7xl mx-auto px-6 py-14 grid md:grid-cols-3 gap-10">
        {/* --- About/Brand Column --- */}
        <div className="space-y-4">
          <p className="text-sm leading-relaxed max-w-xs text-gray-500">
            Experience the art of style and care. We specialize in creating
            looks that reflect your beauty and confidence.
          </p>
        </div>

        {/* --- Contact Column --- */}
        <div className="space-y-3">
          <h3
            className="text-lg font-semibold tracking-wide mb-3 uppercase"
            style={{ color: themeColor }}
          >
            Contact Us.
          </h3>
          <div className="flex items-center space-x-2">
            <Mail className="w-4 h-4" style={{ color: themeColor }} />
            <p className="text-sm text-gray-600">
              {contactDetails.contactEmail}
            </p>
          </div>
        </div>

        {/* --- Quick Links Column --- */}
        <div className="space-y-3">
          <h3
            className="text-lg font-semibold tracking-wide mb-3 uppercase"
            style={{ color: themeColor }}
          >
            Quick Links.
          </h3>
          <ul className="space-y-2">
            {quickLinks.map((link, idx) => (
              <li key={idx}>
                <button
                  onClick={() => handleScroll(link.href)}
                  className="text-sm text-gray-600 hover:underline transition-all cursor-pointer bg-transparent border-none"
                >
                  {link.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* --- Social + Info --- */}
      <div className="max-w-7xl mx-auto px-6 py-8 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center space-x-4">
          {contactDetails.linkedin && (
            <a
              href={contactDetails.linkedin}
              target="_blank"
              rel="noreferrer"
              className="group p-2 rounded-full border transition-all duration-300"
              style={{ borderColor: themeColor, color: themeColor }}
            >
              <Linkedin className="w-5 h-5" />
            </a>
          )}
          {contactDetails.facebook && (
            <a
              href={contactDetails.facebook}
              target="_blank"
              rel="noreferrer"
              className="group p-2 rounded-full border transition-all duration-300"
              style={{ borderColor: themeColor, color: themeColor }}
            >
              <Facebook className="w-5 h-5" />
            </a>
          )}
          {contactDetails.instagram && (
            <a
              href={contactDetails.instagram}
              target="_blank"
              rel="noreferrer"
              className="group p-2 rounded-full border transition-all duration-300"
              style={{ borderColor: themeColor, color: themeColor }}
            >
              <Instagram className="w-5 h-5" />
            </a>
          )}
          {contactDetails.twitter && (
            <a
              href={contactDetails.twitter}
              target="_blank"
              rel="noreferrer"
              className="group p-2 rounded-full border transition-all duration-300"
              style={{ borderColor: themeColor, color: themeColor }}
            >
              <Twitter className="w-5 h-5" />
            </a>
          )}
        </div>

        <p className="text-sm text-gray-600 text-center md:text-left">
          Stay updated with our latest styles and offers.
        </p>
      </div>

      <div
        className="text-center py-5 text-sm font-medium tracking-wide text-gray-500"
        style={{ borderTop: `2px solid ${themeColor}` }}
      >
        © {new Date().getFullYear()} All Rights Reserved.
      </div>
    </footer>

    
  );
};

export default MicrositeContactUs;
